module.exports = __webpack_public_path__ + "img/ws_logo.54b01259.png";